import * as Yup from 'yup';
import { zipCodeValidation, cityValidation } from './utilities';
import { phoneValidator } from 'helpers/regex';

const otherJobFunctionValue = '5';

export const addressValidations = (props) => {
	return {
		dealershipAddress: Yup.string().nullable().required(props.t('signup:steps.step2.addressRequired')),
		dealershipAddress2: Yup.string().nullable(),
		city: cityValidation(props),
		state: Yup.string().nullable().required(props.t('common:fieldRequired')),
		zip: zipCodeValidation(props),
	};
};

export const validationFormStepOne = (props) =>
	Yup.object().shape({
		dealershipAge: Yup.string().nullable().required(props.t('common:selectionRequired')),
		jobFunction: Yup.string().nullable().required(props.t('common:selectionRequired')),
		jobFunctionDescription: Yup.string()
			.nullable()
			.when('jobFunction', (jobFunction, schema) =>
				jobFunction === otherJobFunctionValue ?
					schema.required(props.t('signup:steps.step1.jobTitleRequired'))
				:	schema,
			),
		...addressValidations(props),
		dealershipPhone: Yup.string()
			.nullable()
			.required(props.t('common:phoneRequired'))
			.test('invalidPhone', props.t('phoneRequired'), phoneValidator),
	});
